<template>
  <div class="news1-box">
    <div class="bgPic">
      <div class="picText">
        <span class="title">数字化运营服务商，全渠道数字化信息平台</span><br />
        <span>为企业提供专业、高效的服务</span>
      </div>
      <!-- <div class="pic">
        <img
          src="@/assets/last/bg/优秀案例背景.png"
          alt=""
          style="height: 870px; width: 100%"
        />
      </div> -->
    </div>
    <!--  -->
    <div class="box">
      <div class="new-title">
        <span class="title">新闻动态</span><br />
        <span>news information</span><br>
        <i>——</i>
        <div class="buttons">
          <el-button
            size="medium"
            :type="active == 0 ? 'primary' : ''"
            @click="getbgc(0)"
            >全部</el-button
          >
          <el-button
            size="medium"
            :type="active == 1 ? 'primary' : ''"
            @click="getbgc(1)"
            >产品发布</el-button
          >
          <el-button
            size="medium"
            :type="active == 2 ? 'primary' : ''"
            @click="getbgc(2)"
            >最新动态</el-button
          >
          <el-button
            size="medium"
            :type="active == 3 ? 'primary' : ''"
            @click="getbgc(3)"
            >更新日志</el-button
          >
        </div>
        <div class="box">
           <!--  -->
        <div class="item-box" v-if="active==0||active==3">
          <el-card class="box-card">
            <div class="el-card__body">
              <div class="left">
                <img src="@/assets/last/news/信息安全管理图片.png" alt="" />
              </div>
              <div class="right">
                <p>泽润软件通过ISO27001信息安全管理标准认证</p>
                <p>信息安全已成为泽润软件的核心竞争力之一</p>
                <span>泽润软件 2025-03-03 </span
                ><el-button size="medium" @click="goNews(1)">了解详情</el-button>
              </div>
            </div>
          </el-card>
      </div>
      <!--  -->
        <div class="item-box" v-if="active==0||active==2">
          <el-card class="box-card">
            <div class="el-card__body">
              <div class="left">
                <img src="@/assets/last/news/AICM智能会员管理图片.png" alt="" />
              </div>
              <div class="right">
                

                <p>数字+智能:数字化营销方案服务商</p>
                <p>AICM智能会员管理系统全新升级</p>
                <span>泽润软件  2022-05-16  </span
                ><el-button size="medium" @click="goNews(2)">了解详情</el-button>
              </div>
            </div>
          </el-card>
      </div>
    
      <!--  -->
         <div class="item-box" v-if="active==0||active==1">
          <el-card class="box-card">
            <div class="el-card__body">
              <div class="left">
                <img src="@/assets/last/news/高人效智能客服系统图片.png" alt="" />
              </div>
              <div class="right">
                

                <p>数据+智能∶致力解决互联网时代的企业管理及运营</p>
                <p>高人效智能客服管理方案</p>
                <span>泽润软件 2021-6-07 </span
                ><el-button size="medium" @click="goNews(3)">了解详情</el-button>
              </div>
            </div>
          </el-card>
      </div>
        </div>
      </div>
    </div>
    <!--  -->
    <!-- <div class="footer"></div> -->
     <BottomFooter />

  </div>
</template>

<script>
import BottomFooter from '../bottom.vue'
export default {
  name: "DemoNews1",
  components: {
    BottomFooter
  },
  data() {
    return {
      active: 0,
    };
  },

  mounted() {},

  methods: {
    getbgc(type) {
      this.active = type;
      },
      goNews(type) {
      this.$emit('toggle',type)
    }
  },
};
</script>

<style lang="less" scoped>
.news1-box {
    .bgPic{
         background: url("../../assets/last/bg/优秀案例背景.png") no-repeat;
    background-size: cover;
    height: 870px;
    }
  .picText {
    color: rgb(242, 243, 247);
    text-align: center;
    letter-spacing: 3px;
    line-height: 80px;
    font-family: SourceHanSansCN-Regular-;
    padding-top: 300px;
    .title {
      display: inline-block;
      font-size: 60px;
      font-weight: normal;
      letter-spacing: 7px;
    }

    span {
      font-size: 40px;
    }
    :hover{
      color: rgba(110, 87, 229);
    }
  }
  //
  .buttons {
    text-align: center;
    font-size: 30px;
    .el-button--medium {
        line-height: 1.2;
      font-size: 25px;
      padding: 10px 20px;
      margin: 20px 20px;
      border: none;
      // background-color:rgb(0, 62, 185);
    }
  }
  .box{
    margin-top: 40px;
.new-title{
    font-size: 20px;
    margin-bottom: 20px;
    i{
        color:#3773FF;
    }
.title{
font-size: 36px;
    }
}
.box{
    margin-bottom: 100px;
}
    .item-box {
    margin-bottom: 20px;
    .box-card {
      width: 65%;
      margin: 0 auto;
      .el-card__body {
        padding:20px 40px;
        display: flex;
        // justify-content: space-between;
        justify-content: flex-start;
      }
      .left {
        img {
          width: 120%;
        }
        padding-right: 15%;
      }
      .right {
        text-align: left;
        font-size: 22px;
        .el-button--medium {
          font-size: 20px;
          margin-left: 50px;
          background-color: rgb(46, 34, 61);
          color: #fff;
          padding: 10px 20px;
        }
      }
      :hover{
        color: rgb(64, 158, 255);
      }
    }
  }
  }

  //
//   .footer {
//     background: url("../../assets/last/bg/底部.png") no-repeat;
//     background-size: contain;
//     height: 480px;
//   }
}
</style>